/**
 * Which page numbers a pager renders: three consecutive pages, the current one in the
 * middle, sliding to stay three at either end (1 2 3 … 6 7 8). Fewer pages, all of them.
 * No first/last page and no ellipsis - Previous / Next step one page at a time.
 *
 * This is the one piece of arithmetic in the pager, and it is the piece that was
 * copy-pasted into every table before the shared component existed - so it lives on
 * its own, as plain TypeScript, where it can be checked without rendering anything
 * (see scripts/pagination-window.check.ts).
 *
 * Zero-based, because every caller counts its rows from zero.
 */
export function paginationWindow(page: number, pageCount: number): number[] {
	const total = Math.max(1, pageCount);
	const size = Math.min(3, total);
	const start = Math.min(Math.max(0, page - 1), total - size);
	return Array.from({ length: size }, (_, index) => start + index);
}
